// features/user/userSlice.ts
import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { User, UserDataResponse } from "../../../Interfaces/LoginInterface";

export type UserContextState = UserDataResponse | null;

const initialState: UserContextState = null;

const userSlice = createSlice({
  name: "user",
  initialState: initialState as UserContextState,
  reducers: {
    setUser: (state, action: PayloadAction<User>) => {
      if (state) {
        state.user = action.payload;
      }
    },
    setUserContext: (state, action: PayloadAction<UserDataResponse>) => {
      return action.payload;
    },
    clearUser: () => {
      return null;
    },
  },
});

export const { setUser, setUserContext, clearUser } = userSlice.actions;
export default userSlice.reducer;
